import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 80%;
    margin: auto;
    margin-top: 30px;
    padding-bottom: 160px;
    @media (max-width: 1000px) {
        width: 100%;
    }
    .container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        direction: ltr;
        @media (max-width: 800px) {
            gap: 40px;
            flex-direction: column;
        }
    }
    .title {
        font-weight: 700;
        font-size: 23px;
        color: black;
        @media (max-width: 600px) {
            font-size: 20px;
        }
    }
    .item {
        width: 100% !important;
    }
    .text-section {
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        direction: rtl;
        ${p => p.webConfig.dir === 'ltr' && `
            direction: ltr;
        `}
        @media (max-width: 800px) {
            width: 100%;
        }
    }
    .label {
        font-weight: 500;
        font-size: 16px;
        color: #0D2439;
        line-height: 32px;
    }
    .value {
        font-weight: 500;
        font-size: 16px;
        color: #61788E;
        line-height: 32px;
        margin-top: -10px;
        @media (max-width: 600px) {
            font-weight: 500;
            font-size: 15px;
        color: #61788E;
        line-height: 32px;
        }
    }
`